/** @format */

import {CampaignDailyStatFromQuery} from '../../../types';

const safeDivide = (numerator: number, denominator: number): number => {
  return denominator !== 0 ? numerator / denominator : 0;
};

const roundFloatNumber = (num: number, decimals: number): number => {
  const multiplier = Math.pow(10, decimals);
  return Math.round(num * multiplier) / multiplier;
};

export const calculateKpiFact = (kpiName: string, stat: CampaignDailyStatFromQuery): number => {
  const kpiUpper = kpiName.toUpperCase();

  const totals = stat.dailyStats.reduce(
    (acc, day) => ({
      spent: acc.spent + day.spent,
      clicks: acc.clicks + day.clicks,
      impressions: acc.impressions + day.impressions,
      conversions: acc.conversions + day.conversions,
      revenue: acc.revenue + day.revenue,
      reach: acc.reach + day.reach,
      likes: acc.likes + day.likes,
      comments: acc.comments + day.comments,
      shares: acc.shares + day.shares,
      videoCompleteRate: acc.videoCompleteRate + day.videoCompleteRate,
      avgVideoCompleteCost: acc.avgVideoCompleteCost + day.avgVideoCompleteCost,
    }),
    {
      spent: 0,
      clicks: 0,
      impressions: 0,
      conversions: 0,
      revenue: 0,
      reach: 0,
      likes: 0,
      comments: 0,
      shares: 0,
      videoCompleteRate: 0,
      avgVideoCompleteCost: 0,
    },
  );

  switch (kpiUpper) {
    case 'DRR': {
      const float = safeDivide(totals.spent, totals.revenue) * 100;
      return roundFloatNumber(float, 1);
    }
    case 'CPL': {
      const float = safeDivide(totals.spent, totals.conversions);
      return roundFloatNumber(float, 0);
    }
    case 'VTR': {
      return safeDivide(totals.videoCompleteRate, stat.dailyStats.length);
    }
    case 'REVENUE':
      return totals.revenue;
    case 'REACH':
      return totals.reach;
    case 'AVG_VIDEO_COMPLETE_COST': {
      return safeDivide(totals.avgVideoCompleteCost, stat.dailyStats.length);
    }
    case 'ER': {
      const engagement = totals.likes + totals.comments + totals.shares;
      const quotient = safeDivide(engagement, totals.reach);
      return roundFloatNumber(quotient * 100, 1);
    }
    case 'ROMI': {
      const float = safeDivide(totals.revenue, totals.spent) * 100;
      return roundFloatNumber(float, 1);
    }
    case 'IMPRESSIONS':
      return totals.impressions;
    case 'CPC': {
      const float = safeDivide(totals.spent, totals.clicks);
      return roundFloatNumber(float, 0);
    }
    case 'CLICKS':
      return totals.clicks;
    case 'CONVERSIONS':
      return totals.conversions;
    case 'CPM': {
      const float = safeDivide(totals.spent, totals.impressions) * 1000;
      return roundFloatNumber(float, 1);
    }
    default:
      return 0;
  }
};
